import Moment from 'moment';
import ManageCartPurchased from './manage-cart-purchased';
import LegCollectionUIModel from './leg-collection';
import PaymentSummaryUIModel from './payment-summary';
import EmdVoucherRs from './emd-voucher-rs';
import PricePerPassengerUIModel from './price-per-passenger-type-map';

export default class ManageConfirmationUIModel {
  constructor(
    manageConfirmation = {}
  ) {
    this.cartConfirmation = new ManageCartPurchased(manageConfirmation.cartConfirmation);
    if (manageConfirmation.cartConfirmation.newEmdVoucherRs !== null) {
      this.emdVoucherRs = new EmdVoucherRs(manageConfirmation.cartConfirmation.newEmdVoucherRs);
    }
    this.dailyForecasts = manageConfirmation.dailyForecasts;
    this.itineraryPdf = manageConfirmation.itineraryPdf;
    if (manageConfirmation.legConfirmation !== undefined) {
      this.legConfirmation = new LegCollectionUIModel(manageConfirmation.legConfirmation._collection);
    }
    this.paymentSummary = manageConfirmation.paymentSummary ?
      manageConfirmation.paymentSummary._collection.map((payment) => {
        return new PaymentSummaryUIModel(payment);
      })
      : null;
    this.pricePerPassengerTypeMap = new PricePerPassengerUIModel(manageConfirmation.pricePerPassengerTypeMap);
    this.responseManageUpdateItineraryConcur = manageConfirmation.isCorporateFlow;
    this.onHoldWrapper = manageConfirmation.onHoldWrapper;
    this.transactionId = manageConfirmation.transactionId;
    if (manageConfirmation.transactionTime) {
      Moment.locale('es-mx');
      this.transactionTime = Moment.utc(manageConfirmation.transactionTime);
    }
    this.warnings = manageConfirmation.warnings;
  }

  getTaxDetailsAsList() {
    return this.cartConfirmation.getTaxDetailsAsList();
  }

  getStreetAddress(paymentSummary) {
    return paymentSummary ? paymentSummary.getStreetAddress() : '';
  }

  getCountryAddress(paymentSummary) {
    return paymentSummary ? paymentSummary.getCountryAddress() : '';
  }

  getSegmentCodesForAllLegs() {
    return this.legConfirmation.getSegmentCodesForAllLegs();
  }

  getUnPaidSegmentChoice(segments) {
    return this.cartConfirmation.getUnPaidSegmentChoice(segments);
  }

  getTicketedSegmentChoice(segments) {
    return this.cartConfirmation.getTicketedSegmentChoice(segments);
  }

  getTicketedUpgradeType() {
    return this.cartConfirmation.getTicketedUpgradeType();
  }

  getTicketedUpgradeSegmentCodes() {
    return this.cartConfirmation.getTicketedUpgradeSegmentCodes();
  }

  getSegmentByCode(segmentCode) {
    return this.legConfirmation.getSegmentByCode(segmentCode);
  }

  getAllPassengers() {
    return this.cartConfirmation.getAllPassengers();
  }

  getAllTicketedCBX() {
    return this.cartConfirmation.getAllTicketedCBX();
  }

  getTravelerById(travelerId) {
    return this.getAllPassengers().find(traveler => {
      return traveler.id === travelerId;
    });
  }

  getLegByCode(legCode) {
    return this.legConfirmation.getLegByCode(legCode);
  }

  getLegCodesForAllLegs() {
    const legCodes = new Array();
    this.legConfirmation._legCollection.forEach(legModel => {
      legCodes.push(legModel.legCode);
    });
    return legCodes;
  }

  hasTicketedAncillary() {
    return this.cartConfirmation.hasTicketedAncillary();
  }

  hasTicketedAncillaryPP() {
    return this.cartConfirmation.hasTicketedAncillaryPP();
  }

  hasTicketedSeat() {
    return this.cartConfirmation.hasTicketedSeat();
  }

  hasTicketedSeatPP() {
    return this.cartConfirmation.hasTicketedSeatPP();
  }

  hasTicketedUpgrade() {
    return this.cartConfirmation.hasTicketedUpgrade();
  }

  isTicketedPremierLight() {
    return this.cartConfirmation.isTicketedPremierLight();
  }

  getBaggageTicketedAncillaries() {
    return this.cartConfirmation.getBaggageTicketedAncillaries();
  }

  getCarryOnTicketedAncillaries() {
    return this.cartConfirmation.getCarryOnTicketedAncillaries();
  }

  getSpecialBaggageTicketedAncillaries() {
    return this.cartConfirmation.getSpecialBaggageTicketedAncillaries();
  }
}
